<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-07-16 15:20:49
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2022-07-17 18:41:13
 * @FilePath: \manger\src\views\NewOrder\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="width: 100%; height: 100%">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>最新交易</span>

        <el-select
          size="mini"
          v-model="value"
          placeholder="请选择"
          style="float: right; padding: 3px 0"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="orderTableBox">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          :header-cell-style="rowClass"
          :cell-style="cellStyle"
          @row-dblclick="openDetails"
        >
          <el-table-column prop="txhash" label="交易信息" width="300">
          </el-table-column>
          <el-table-column
            prop="time"
            label="交易时间"
            sortable
            width="180"
            column-key="date"
            :filters="[
              { text: '2016-05-01', value: '2016-05-01' },
              { text: '2016-05-02', value: '2016-05-02' },
              { text: '2016-05-03', value: '2016-05-03' },
              { text: '2016-05-04', value: '2016-05-04' },
            ]"
            :filter-method="filterHandler"
          >
          </el-table-column>
          <el-table-column prop="from" label="发起账户">
            <template slot-scope="scope">
              <p style="color: #409eff" @click="openAdressDel(scope.row.from)">
                {{ scope.row.from }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="to" label="目标账户">
            <template slot-scope="scope">
              <p style="color: #409eff" @click="openAdressDel(scope.row.to)">
                {{ scope.row.to }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="methods" label="交易方法">
            <template slot-scope="scope">
              <p>{{ getType(scope.row.method) }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="height" label="区块高度"> </el-table-column>
          <el-table-column prop="value" label="交易金额"> </el-table-column>
        </el-table>
        <div style="display: flex; justify-content: end">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="count"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog title="交易详情" :visible.sync="nftBuy" width="80%">
        <div style="width: 100%; height: 68vh">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="color: black; font-size: 20px; font-weight: bold"
                >交易哈希 {{ newDalData.txhash }}</span
              >
            </div>
            <div style="width: 100%; height: 150px">
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">交易时间</div>
                  <div style="width: 20%; height: 50px">
                    {{ newDalData.time }}
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">区块高度</div>
                  <div style="width: 20%; height: 50px; color: #409eff">
                    {{ newDalData.height }}
                  </div>
                </div>
              </div>

              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">发起账户</div>
                  <div style="width: 20%; height: 50px">
                    {{ newDalData.from }}
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">方法</div>
                  <div style="width: 20%; height: 50px">
                    {{ getType(newDalData.method) }}
                  </div>
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">目标账户</div>
                  <div style="width: 20%; height: 50px">
                    {{ newDalData.to }}
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">金额</div>
                  <div style="width: 20%; height: 50px">
                    ￥{{ newDalData.value }}
                  </div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card
            class="box-card"
            style="margin-top: 25px"
            v-if="
              chooseData.methods == 4 ||
              chooseData.methods == 3 ||
              chooseData.methods == 6
            "
          >
            <div slot="header" class="clearfix">
              <span style="color: black; font-size: 20px; font-weight: bold"
                >交易数据
              </span>
            </div>
            <div style="width: 100%">
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">起始NFT ID</div>
                  <div style="width: 50%; height: 50px; color: #409eff">
                    a67be44ac4e904eBe004148f434069
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px"></div>
                  <div style="width: 20%; height: 50px"></div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card
            class="box-card"
            style="margin-top: 25px"
            v-if="chooseData.method == 'nft销售信息变更'"
          >
            <div slot="header" class="clearfix">
              <span style="color: black; font-size: 20px; font-weight: bold"
                >交易数据
              </span>
            </div>
            <div style="width: 100%">
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">起始NFT ID</div>
                  <div style="width: 50%; height: 50px">
                    a67be44ac4e904eBe004148f434069
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">销售状态</div>
                  <div style="width: 20%; height: 50px">可销售</div>
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">售价</div>
                  <div style="width: 50%; height: 50px">2</div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px"></div>
                  <div style="width: 20%; height: 50px"></div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card
            class="box-card"
            style="margin-top: 25px"
            v-if="chooseData.method == '1'"
          >
            <div slot="header" class="clearfix">
              <span style="color: black; font-size: 20px; font-weight: bold"
                >交易数据
              </span>
            </div>
            <div style="width: 100%">
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">系列ID</div>
                  <div style="width: 50%; height: 50px">
                    a67be44ac4e904eBe004148f434069
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">系列名</div>
                  <div style="width: 20%; height: 50px">戏中曲|R数字作品</div>
                </div>
              </div>
            </div>
            <div style="width: 100%">
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">发行量</div>
                  <div style="width: 50%; height: 50px">30</div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">创作者地址</div>
                  <div style="width: 50%; height: 50px; color: #409eff">
                    <p @click="goToNftDetails">
                      a67be44ac4e904eBe004148f434069
                    </p>
                  </div>
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">封面面地址</div>
                  <div style="width: 50%; height: 50px">
                    https://blog.csdn.net//article/details/112304742
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px"></div>
                  <div style="width: 20%; height: 50px"></div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card
            class="box-card"
            style="margin-top: 25px"
            v-if="chooseData.method == 2"
          >
            <div slot="header" class="clearfix">
              <span style="color: black; font-size: 20px; font-weight: bold"
                >交易数据
              </span>
            </div>
            <div style="width: 100%">
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">起始NFT ID</div>
                  <div style="width: 50%; height: 50px">
                    a67be44ac4e904eBe004148f434069
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">系列名</div>
                  <div style="width: 20%; height: 50px">戏中曲|R数字作品</div>
                </div>
              </div>
            </div>
            <div style="width: 100%">
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">系列ID</div>
                  <div style="width: 50%; height: 50px">
                    a67be44ac4e904eBe004148f434069
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">作者名</div>
                  <div style="width: 50%; height: 50px">天**</div>
                </div>
              </div>

              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">发行量</div>
                  <div style="width: 50%; height: 50px">2</div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">作品名称</div>
                  <div style="width: 20%; height: 50px">百年无极-《园丁》</div>
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">作品url</div>
                  <div style="width: 50%; height: 50px">
                    a67be44ac4e904eBe004148f434069
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px"></div>
                  <div style="width: 20%; height: 50px"></div>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </el-dialog>
      <el-dialog title="NFT详情" :visible.sync="NftDetailShow" width="80%">
        <div>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="color: black; font-size: 20px; font-weight: bold"
                >账号ID ZXb12c8b4c65bcc9217d0908d56695c90932620ed5</span
              >
            </div>
          </el-card>
        </div></el-dialog
      >
      <el-dialog title="地址详情" :visible.sync="showAdressDel" width="80%">
        <div>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="color: black; font-size: 20px; font-weight: bold"
                >地址 {{ chooseAddress }}
              </span>
            </div>
            <div style="width: 100%; height: 30px">
              <div
                style="
                  width: 100%;
                  height: 30px;
                  display: flex;
                  justify-content: space-around;
                "
              >
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px">交易数量</div>
                  <div style="width: 20%; height: 50px">
                    {{ addressNum }}
                  </div>
                </div>
                <div style="width: 50%; display: flex">
                  <div style="width: 20%; height: 50px"></div>
                  <div style="width: 20%; height: 50px; color: #409eff"></div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card class="box-card" style="margin-top: 25px">
            <div slot="header" class="clearfix">
              <div
                style="
                  height: 50px;
                  width: 200px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div
                  style="
                    width: 80px;
                    height: 50px;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 50px;
                  "
                  @click="activeIndx = 1"
                  :class="[activeIndx == 1 ? 'activeText' : 'deactiveText']"
                >
                  交易记录
                </div>
                <div
                  style="
                    width: 80px;
                    height: 50px;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 50px;
                  "
                  @click="activeIndx = 2"
                  :class="[activeIndx == 2 ? 'activeText' : 'deactiveText']"
                >
                  资产列表
                </div>
              </div>
            </div>
            <el-table
              v-show="activeIndx == 1"
              :data="adressTableData"
              style="width: 100%"
              border
              :header-cell-style="rowClass"
              :cell-style="cellStyle"
              @row-dblclick="openDetails"
            >
              <el-table-column prop="txhash" label="交易信息" width="300">
              </el-table-column>
              <el-table-column
                prop="time"
                label="交易时间"
                sortable
                width="180"
                column-key="date"
                :filters="[
                  { text: '2016-05-01', value: '2016-05-01' },
                  { text: '2016-05-02', value: '2016-05-02' },
                  { text: '2016-05-03', value: '2016-05-03' },
                  { text: '2016-05-04', value: '2016-05-04' },
                ]"
                :filter-method="filterHandler"
              >
              </el-table-column>
              <el-table-column prop="from" label="发起账户">
                <template slot-scope="scope">
                  <p style="color: #409eff">
                    {{ scope.row.from }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="to" label="目标账户">
                <template slot-scope="scope">
                  <p style="color: #409eff">
                    {{ scope.row.to }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="methods" label="交易方法">
                <template slot-scope="scope">
                  <p>{{ getType(scope.row.method) }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="height" label="区块高度">
              </el-table-column>
              <el-table-column prop="value" label="交易金额"> </el-table-column>
            </el-table>
            <el-table
              v-show="activeIndx == 2"
              :data="adressTableData2"
              style="width: 100%"
              border
              :header-cell-style="rowClass"
              :cell-style="cellStyle"
            >
              <el-table-column prop="tokenID" label="资产ID" width="300">
              </el-table-column>

              <el-table-column prop="author" label="作者名"> </el-table-column>
              <el-table-column prop="title" label="作品名称"> </el-table-column>
              <el-table-column prop="time" label="获得时间"> </el-table-column>
            </el-table>
          </el-card></div
      ></el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      activeIndx: 1,
      showAdressDel: false,
      adressTableData: [],
      adressTableData2: [],
      NftDetailShow: false,
      nftBuy: false,
      tableData: [],
      options: [
        {
          value: 0,
          label: "全部方法",
        },
        {
          value: 1,
          label: "nft系列声明",
        },
        {
          value: 2,
          label: "nft发行",
        },
        {
          value: 3,
          label: "nft转移",
        },
        {
          value: 4,
          label: "nft购买",
        },
        {
          value: 5,
          label: "nft销售信息变更",
        },
        {
          value: 6,
          label: "哈希存证",
        },
      ],
      chooseAddress: "",
      value: 0,
      chooseData: {},
      newDalData: {
        method: 2,
      },
      page: 1,
      limit: 10,
      count: 0,
      addressNum: "",
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    openAdressDel(e) {
      console.log(e);
      axios
        .post("/api/address/txlist", {
          address: e,
          method: 0,
          page: 1,
          limit: 10,
        })
        .then((res) => {
          console.log(res.data.data);
          this.addressNum = res.data.data.count;
          this.adressTableData = res.data.data.list;
          this.chooseAddress = e;
          this.showAdressDel = true;
        });
      axios
        .post("/api/address/nftlist", {
          address: e,

          page: 1,
          limit: 10,
        })
        .then((res) => {
          this.adressTableData2 = res.data.data.list;
        });
    },
    getType(data) {
      let hh = data + 1;
      console.log(data);
      // console.log(hh);
      const found = this.options.find((element) => element.value == hh);
      console.log(found);
      return found.label;
    },
    getTableData() {
      axios
        .post("/api/tx/list", {
          method: this.value,
          page: this.page,
          limit: this.limit,
        })
        .then((res) => {
          console.log(res.data.data.list);
          this.tableData = res.data.data.list;
          this.count = res.data.data.count;
          // this.showMyEcharts(res.data.data);
          // res.data
        })
        .catch((err) => {
          // 处理捕获的错误err
          console.log(err);
        });
    },
    handleClose() {},
    rowClass() {
      //   console.log(rowIndex); //表头行下标
      return "color:black";
    },
    cellStyle() {
      return "font-size:12px";
    },
    resetDateFilter() {
      this.$refs.filterTable.clearFilter("date");
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    formatter(row) {
      return row.address;
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.limit = val;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    openDetails(e) {
      console.log(e);
      this.chooseData = e;
      this.getDetalisData(e.txhash);
      this.nftBuy = true;
    },
    getDetalisData(data) {
      axios
        .post("/api/tx/getTxInfo", {
          txHash: data,
        })
        .then((res) => {
          console.log(res.data.data);
          this.newDalData = res.data.data;
          // this.count = res.data.data.count;
          // this.showMyEcharts(res.data.data);
          // res.data
        });
    },
    goToNftDetails() {
      this.NftDetailShow = true;
    },
  },
};
</script>

<style>
.orderTableBox {
  width: 100%;
  height: 74vh;
  /* background-color: aqua; */
}
.activeText {
  color: rgb(0, 0, 0);
}
.deactiveText {
  color: rgb(182, 182, 182);
}
</style>